import { IllustrationLoaders } from './lazyIllustrationRegistry'
import { createLazyAssetGetter } from '../lazyAssetRegistry'

/**
 * Lazily loads an illustration component by its export name, e.g. for config-driven keys.
 *
 * Example:
 * const Illustration = loadIllustrationComponent(illustrationName)
 * return <Illustration {...props} fallback={optionalFallbackComponent} />
 *
 * illustrationName must be a valid entry in IllustrationLoaders.
 * An invalid illustrationName will eagerly throw an error in dev,
 * or render the fallback in production.
 */
export const loadIllustrationComponent = createLazyAssetGetter('IllustrationLoaders', IllustrationLoaders)
